<template>
  <div v-if="data" ref="echars" class="echars-class">
  </div>
</template>

<script>
export default {
  name: "distributed",
  data: () => ({
    chats: undefined,
    data: undefined
  }),
  methods: {
    init(data) {
      this.data = data

      let _data = []
      this.data.forEach(item => {
        _data.push({
          name: item.salaryRange,
          value: item.percent,
        })
      })

      let option = {
        // title: {
        //   text: '收入区间分布（单位: 人民币/万）'
        // },
        grid: {
          left: '0',
          containLabel: true,
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          type: 'category',
          data: _data.map(item => item.name),
          axisLabel: {
            formatter(params) {
              return `${params} 万`
            }
          }
        },
        series: [
          {
            barGap: -120,
            barWidth: 25,
            label: {
              show: true,
              formatter: "{c} %"
            },
            type: 'bar',
            data: _data
          },
        ]
      };

      this.$nextTick(() => {
        this.chats = this.$echarts.init(this.$refs.echars, 'vintage', {renderer: 'canvas'})
        this.chats.setOption(option);
        this.chats.resize();
      })
    },
    resize() {
      this.$nextTick(() => {
        if (this.chats) {
          this.chats.resize();
        }
      })
    }
  }
}
</script>

<style scoped>
.echars-class {
  width: 100%;
  height: 100%;
}
</style>
